import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentBlock,
  ModalSheetContentDescription,
  ModalSheetContentIllustration,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
} from 'components/ModalSheet'
import BulkCopyJobViewModel from './BulkCopyJobViewModel'
import { observer } from 'mobx-react'
import * as React from 'react'
import Button from 'components/Button'

interface CopyJobDialogProps {
  vm: BulkCopyJobViewModel
}

/**
 * The BulkCopyJobDialog
 */
export default observer(function BulkCopyJobsDialog({
  vm,
}: CopyJobDialogProps) {
  return (
    <ModalSheet showing={vm.showing} onRequestClose={vm.close}>
      <ModalSheetHeader withCloseButton />
      <ModalSheetContent>
        <ModalSheetContentBlock>
          <ModalSheetContentIllustration
            src={require('assets/images/img_create-flows.svg')}
            alt="Clone Jobs"
          />
          <ModalSheetContentTitle>
            You’re about to clone {vm.jobsCount} job
            {vm.jobsCount > 1 ? 's' : ''}
          </ModalSheetContentTitle>
          <ModalSheetContentDescription>
            Before proceeding, make sure you have selected the correct jobs.
            Once cloned, this action cannot be undone.
          </ModalSheetContentDescription>
        </ModalSheetContentBlock>
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button onClick={vm.close}>Cancel</Button>
          <Button
            onClick={() => vm.copyJobs()}
            disabled={vm.copyJobs.pending}
            type="primary"
            dataTest="copy-job-modal-confirm"
          >
            Clone
          </Button>
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
})
